import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../../api/agent";
import { AppResponse } from "../../../../../models/app/AppResponse";
import { RuleActionType } from "../../../../../models/features/ShopifySetting/Portal Setting Rules/PortalSettingRules";
import { PayPalSetting } from "../../../../../models/features/Gravity/Gravity";
import { Paging } from "../../../../../models/app/AppModels";

export const dealerCustomersApi = createApi({
  reducerPath: "dealerCustomersApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    getCustomers: build.mutation<
      any,
      { paging: Paging; everestDmsDealerId: string; search: string }
    >({
      query: (data) => ({
        url: `api/DmsSetup/GetCustomers`,
        method: "post",
        data: {
          request: {
            ...data.paging,
            everestDmsDealerId: data.everestDmsDealerId,
            search: data.search,
          },
        },
      }),
    }),
  }),
});

export const { useGetCustomersMutation } = dealerCustomersApi;
export const dealerCustomersReducer = dealerCustomersApi.reducer;
